import { render, staticRenderFns } from "./SimilarCoaches.vue?vue&type=template&id=8fd41e90&"
import script from "./SimilarCoaches.vue?vue&type=script&lang=js&"
export * from "./SimilarCoaches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports